import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import UpgradeButton from '../../components/UpgradeButton';

const DowngradeButton = ({ onClick }) => (
  <Button
    variant="contained"
    color="error"
    disableRipple
    onClick={onClick}
    sx={{
      textTransform: 'none',
      boxShadow: 'none',
      '&:hover': { boxShadow: 'none' },
    }}
  >
    Continue with Downgrade
  </Button>
);

const SubscriptionExpiredPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = 'Confirm Downgrade - The Simple Platform';
  }, []);

  return (
    <div>
      <div style={{ textAlign: 'center' }}>
        <h2 style={{ marginBottom: '16px' }}>Confirm Downgrade to Explorer</h2>
        <p style={{ margin: 0 }}>
          Downgrading will move your account to the Explorer plan and apply Free Account limits.
        </p>
        <p style={{ marginTop: '4px' }}>
          If you'd like to keep Full Access, you can return to your subscription settings.
        </p>
        <div
          style={{
            display: 'flex',
            marginTop: '32px',
            alignItems: 'center',
            justifyContent: 'space-evenly',
          }}
        >
          <UpgradeButton text="Return to Subscription" />
          <DowngradeButton onClick={() => navigate('/confirm-downgrade')} />
        </div>
      </div>
    </div>
  );
};

export default SubscriptionExpiredPage;
